import $ from "jquery";
// import 'select2'

function init_select2(id, data = [], placeholder = 'Seleccionar una opción'){
    let list = [{'id': '', 'text': ''}, ...data]
    $('#'+id).select2({
        placeholder: placeholder,
        data: list,
        tokenSeparators: [',', ' '],
        allowClear: true,
        theme: "classic",
        width: 'resolve'
    });
};

function getProductos() {
    $('#product_product_type').val();
    $('#product_name').empty();

    const container = document.getElementById("products-container");
    const products = JSON.parse(container.dataset.products);
    ccyan($('#product_product_type').val(), 'products')
    products.forEach(function(currentValue, index, array) {
        // code to be executed for each element
        if($('#product_product_type').val() === currentValue.type_key) {
            let result = currentValue.list.map(item => ({'id': item.key, 'text': item.name}));
            ccyan(result, 'result')
            init_select2('product_name', result, 'Seleccionar producto')
        }

    }); // thisArg is optional


    // let path = '/get/vehicle/makes/'+$('#vehicle_vehicles_years_id').val()
    // return getVehicles('makes', 'vehicle_vehicles_years_id', 'vehicle_vehicles_makes_id', path, $('#make_id').val())
}

function destroyProductos() {
    if(document.getElementById('products-form')) {
        $(document)
            .off('select2:select', '#product_product_type', getProductos)
        document.removeEventListener('turbolinks:load', setupProductos);
        document.removeEventListener('turbolinks:before-cache', destroyProductos);
    }
}

function setupProductos() {
    if(document.getElementById('products-form')) {
        $(document)
            .on('select2:select', '#product_product_type', getProductos)
    }
}

document.addEventListener('turbolinks:load', setupProductos);
document.addEventListener('turbolinks:before-cache', destroyProductos);
